import i18n from '@/i18n'

export const catchError = function (error, context) {
  if (error.status === 401) {
    context.dispatch('DELETE_AUTHORIZATION')
  } else if (error.status === 412) {
    context.commit('SET_GLOBAL_LOADING', false)
    if (!error.body) error.body = {}
    const messages = [{ message: i18n.t('alert.password-error') }]
    error.body.errors ? error.body.errors.push(messages) : error.body.errors = messages
  } else if (error.status === 400 && error.body.notifications) {
    const notifications = Object.values(error.body.notifications)
    const messages = notifications.map(message => { return { message: message[0] } })
    error.body.errors ? error.body.errors.push(messages) : error.body.errors = messages
  } else if (error.status === 422) {
    const errors = Object.keys(error.body.errors)
    error.body.errors = [...errors]
  } else if (error.status !== 400 && error.status !== 422) {
    context.commit('SET_GLOBAL_LOADING', false)
    context.commit('toggleGlobalError', { status: true, code: error.status })
  }
  if (window.newrelic) { window.newrelic.noticeError(error.message) }
  return Promise.reject(error)
}
